/**
 * @generated SignedSource<<ab2aaab4af7e9dbaa700975bcb638e27>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type Permission = "ADD" | "DEPLOY_POLICIES" | "EDIT" | "EDIT_ACL" | "LOGIN" | "REMOVE" | "VIEW" | "VIEW_ACL" | "VIEW_RESOURCES" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type UpsertDpcForm_policyCollection$data = {
  readonly autoUpdate: boolean;
  readonly description: string | null | undefined;
  readonly name: string;
  readonly repositoryView: {
    readonly branchName: string | null | undefined;
    readonly policyDirectories: ReadonlyArray<string> | null | undefined;
    readonly policyFileSuffix: ReadonlyArray<string> | null | undefined;
  } | null | undefined;
  readonly userPermissions: ReadonlyArray<Permission>;
  readonly uuid: any;
  readonly " $fragmentSpreads": FragmentRefs<"ACLFormFields_acl">;
  readonly " $fragmentType": "UpsertDpcForm_policyCollection";
};
export type UpsertDpcForm_policyCollection$key = {
  readonly " $data"?: UpsertDpcForm_policyCollection$data;
  readonly " $fragmentSpreads": FragmentRefs<"UpsertDpcForm_policyCollection">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "UpsertDpcForm_policyCollection",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "autoUpdate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "uuid",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "RepositoryView",
      "kind": "LinkedField",
      "name": "repositoryView",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "branchName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "policyDirectories",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "policyFileSuffix",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "userPermissions",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ACLFormFields_acl"
    }
  ],
  "type": "PolicyCollection",
  "abstractKey": null
};

(node as any).hash = "915b6415e89912ef6914591a39cb42d8";

export default node;
